import UserDocuments from "../components/Admin/UserDocuments";
import Dashboard from "../components/Dashboard";
import Documents from "../components/Documents";
import ForgotPassword from "../components/ForgotPassword/ForgotPassword";
import Login from "../components/Login/";
import ResetPassword from "../components/ResetPassword/ResetPassword";

export const getRoutes = () => {
  return [
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/forgot-password",
      element: <ForgotPassword />,
    },
    {
      path: "/reset-password",
      element: <ResetPassword />,
    },
    {
      path: "/dashboard",
      element: <Dashboard />,
    },
    {
      path: "/documents",
      element: <Documents />,
    },
    {
      path: "/user-documents",
      element: <UserDocuments />,
    },
  ];
};